var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0755 5.51909V20.8837C19.0755 22.519 17.7497 23.8448 16.1144 23.8448H3.08552C1.45015 23.8448 0.12442 22.519 0.12442 20.8837V3.11707C0.12442 1.4817 1.45015 0.155972 3.08552 0.155972H13.7123C13.8696 0.146 14.0332 0.198422 14.1642 0.32943L18.902 5.06719C19.033 5.19819 19.0854 5.36186 19.0755 5.51909ZM13.1533 1.34041H3.08552C2.1043 1.34041 1.30886 2.13585 1.30886 3.11707V20.8837C1.30886 21.8649 2.1043 22.6603 3.08552 22.6603H16.1144C17.0956 22.6603 17.891 21.8649 17.891 20.8837V6.07817H13.7455C13.4184 6.07817 13.1533 5.81302 13.1533 5.48595V1.34041ZM14.3377 2.17794V4.89373H17.0535L14.3377 2.17794ZM9.59994 10.4678V18.5136C9.59994 18.8407 9.33479 19.1058 9.00772 19.1058C8.68064 19.1058 8.4155 18.8407 8.4155 18.5136V10.4678L5.87316 13.0102C5.64188 13.2414 5.26691 13.2414 5.03563 13.0102C4.80436 12.7789 4.80436 12.4039 5.03563 12.1726L8.58895 8.61932C8.82023 8.38804 9.1952 8.38804 9.42648 8.61932L12.9798 12.1726C13.2111 12.4039 13.2111 12.7789 12.9798 13.0102C12.7485 13.2414 12.3735 13.2414 12.1423 13.0102L9.59994 10.4678Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitAssessment);
export default __webpack_public_path__ + "static/media/submit-assessment.ad6c62154052ab0d94fdb452d73254f1.svg";
export { ForwardRef as ReactComponent };